document.addEventListener('DOMContentLoaded', function() {
  // Function to generate TOC
  function generateTOC() {
    const headings = document.querySelectorAll('.article h2, .article h3, .article h4');
    const tocContainer = document.querySelector('#toc');
    const tocList = document.createElement('ul');
    
    headings.forEach((heading, index) => {
      const id = 'heading-' + index;
      heading.id = id;
      
      const listItem = document.createElement('li');
      const link = document.createElement('a');
      link.setAttribute('href', `#${id}`);
      link.innerText = heading.innerText;
      listItem.appendChild(link);
      tocList.appendChild(listItem);
    });
    
    tocContainer.appendChild(tocList);
  }

  // Adjust scroll behavior when clicking on TOC links
  const tocLinks = document.querySelectorAll('#toc a');
  tocLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      
      // Get the target element
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      // Scroll to the target with an offset for the fixed/sticky header
      if (targetElement) {
        // Select the sticky header using its class
        const header = document.querySelector('.site-header--stuck');
        
        if (header) {
          // Use getBoundingClientRect() to get the actual height of the sticky header
          const headerHeight = header.getBoundingClientRect().height;

          // Apply margin-top to the heading for spacing after scroll
          targetElement.style.marginTop = `${headerHeight}px`;

          // Scroll to the target element with the adjusted margin
          window.scrollTo({
            top: targetElement.getBoundingClientRect().top + window.scrollY - headerHeight,
            behavior: 'smooth',
          });

          // Remove the margin-top after a brief delay to allow for smooth scrolling
          setTimeout(() => {
            targetElement.style.marginTop = ''; // Reset margin-top
          }, 500); // Adjust delay as needed (500ms is a typical smooth scroll duration)
        }
      }
    });
  });

  // Only generate TOC if #toc exists in the DOM
  if (document.querySelector('#toc')) {
    generateTOC();
  }
});